// applicant/src/organisms/ReCaptchaErrorModal.tsx
import React from 'react';
import { Button } from '../atoms/Button';
import { Modal } from '@mui/material';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';

interface ReCaptchaErrorModalProps {
  onClose: () => void;
}

const ReCaptchaErrorModal: React.FC<ReCaptchaErrorModalProps> = ({ onClose }) => {
  const { t: tCommons } = useTranslationWithLang('commons');
  return (
    <Modal
      open={true}
      onClose={onClose}
      role="dialog"
      aria-describedby="modal-modal-description"
      aria-labelledby="modal-modal-title"
    >
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[400px] bg-[var(--c-background2)] rounded-[10px] p-4 border border-[var(--c-primary-color)] min-h-[20rem] max-h-[80vh] flex flex-col justify-between items-center">
        <h2 id="modal-modal-title" className="sr-only">
          {tCommons('TU000_095')}
        </h2>
        <div className="flex-1 flex items-center justify-center w-full">
          <div>
            <p className="text-center break-words">{tCommons('TU000_095')}</p>
            <p className="text-center break-words">{tCommons('TU000_096')}</p>
            <p className="break-words mt-4">{tCommons('TU000_097')}</p>
            <p className="break-words">{tCommons('TU000_098')}</p>
            <p className="break-words">{tCommons('TU000_099')}</p>
            <p className="break-words">{tCommons('TU000_100')}</p>
            <p className="break-words">{tCommons('TU000_101')}</p>
            <p className="break-words">{tCommons('TU000_102')}</p>
            <p className="break-words">{tCommons('TU000_103')}</p>
            <p className="break-words">{tCommons('TU000_104')}</p>
          </div>
        </div>
        <div className="flex justify-center w-full mt-4 mb-auto">
          <Button label={tCommons('TU000_028')} onClick={onClose} />
        </div>
      </div>
    </Modal>
  );
};

export default ReCaptchaErrorModal;
